import { clientSlice } from './slice';

export default clientSlice.reducer;
